// © Microsoft Corporation. All rights reserved.

/**
 * Shallow compare of two objects.
 * Compares reference and primitive values of both object's key-value pairs
 *
 * @param a
 * @param b
 * @returns {bool} result of comparison.
 */
export function ShallowCompare(a: Object, b: Object): boolean {
    for (const key in a) {
        if (!(key in b) || a[key] !== b[key]) {
            return false;
        }
    }

    for (const key in b) {
        if (!(key in a) || a[key] !== b[key]) {
            return false;
        }
    }

    return true;
}
